<template>
    <div id="voiceMessagePlayer">
        <audio :src="getSrc()" controls></audio>
    </div>
</template>

<script>
export default {
    name: "VoiceMessage",
    props: ["data"],
    methods: {
        getSrc() {
            const asset = this.data.asset;
            const src =
                asset.path.indexOf("whatsapp") !== -1
                    ? `https://static.supsis.live/${asset.path}`
                    : `https://static.supsis.live/${asset.path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
    },
};
</script>

<style lang="scss" scoped>
#voiceMessagePlayer {
    audio {
        height: 30px;
    }
}
</style>
